import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-[#FAF9F6] mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-serif-display text-4xl md:text-5xl leading-none tracking-tight">
            EarthOrg<br/>Ventures LLP
          </h3>
          <p className="mt-6 text-sm leading-relaxed text-[#D5D1C5] max-w-sm">
            Single-origin saffron, raw honey and heritage spices —
            traceable from the farms of India to kitchens worldwide.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-overline text-[#7A7A7A] mb-4">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop" data-testid="footer-shop" className="hover:text-[#C84B31]">Shop</Link></li>
            <li><Link to="/our-sourcing" data-testid="footer-sourcing" className="hover:text-[#C84B31]">Our Sourcing</Link></li>
            <li><Link to="/wholesale" data-testid="footer-wholesale" className="hover:text-[#C84B31]">Wholesale</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-[#C84B31]">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-overline text-[#7A7A7A] mb-4">Registered</p>
          <p className="text-sm text-[#D5D1C5] leading-relaxed">
            EarthOrg Ventures LLP<br/>
            Export House · Government of India recognised<br/>
            FSSAI Licensed · Spices Board Registered
          </p>
          <p className="mt-6 text-xs text-[#7A7A7A]">© {new Date().getFullYear()} EarthOrg Ventures LLP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
